module.exports = __webpack_public_path__ + "ht.b269aba7.svg";